export default {
  title: 'Coparticipação',
  description: 'A coparticipação é um valor fixo em dólares que você precisa pagar por serviços de saúde ou medicamentos cobertos, conforme definido pelo seu plano de saúde.',
  'is-paid': 'está pago',
}
